import { render } from "./TripsTable.vue?vue&type=template&id=2c30ffe5"
import script from "./TripsTable.vue?vue&type=script&lang=js"
export * from "./TripsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__